import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import _ from 'lodash';

class SecureFile extends DomainObject {
  id;
  awsFiles = [];

  _relations = {
    awsFiles: [AttachedDocument]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      awsFiles: observable,
      hasFiles: computed
    });

    this.merge(other);
  }

  get hasFiles() {
    return !_.isEmpty(this.awsFiles);
  }
}

export default SecureFile;
